import { Button } from '@storeblocks/button';
import { Input } from '@storeblocks/input';
import { type FC, useState } from 'react';
import styled from 'styled-components';

import { DebugSurface } from './DebugSurface';

export const ThrowError: FC = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState<string | undefined>(
    undefined,
  );

  return (
    <DebugSurface>
      <p>Throw an error and the global error boundary will catch it.</p>
      <Container>
        <Input
          id="throw-error-input-message"
          name="throw-error-input-message"
          label="Error message"
          value={errorMessage}
          onChange={(e) => {
            setErrorMessage(e.target.value);
            setSuccessMessage(undefined);
          }}
          alert={{
            messageType: successMessage ? 'success' : undefined,
            message: successMessage,
          }}
          fluid
        />
        <ButtonWrapper>
          <Button
            onClick={() => {
              setSuccessMessage('Done, check console');

              throw new Error(errorMessage);
            }}
            disabled={errorMessage === ''}
          >
            Throw
          </Button>
        </ButtonWrapper>
      </Container>
    </DebugSurface>
  );
};

const Container = styled.div`
  display: flex;
  gap: 24px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`;
